import { SortOrder, Worklog, WorklogWhereInput } from '../../../generated/graphql'

type ActiveWorklog = Pick<
  Worklog,
  | 'id'
  | 'end_time'
  | 'deleted_at'
  | 'general_activity'
  | 'specific_activity'
  | 'activity_objective'
  | 'start_time'
>

interface ResolveActiveWorklogParams {
  userId?: string
  storedWorklogId?: string | null
  fetchWorklogs: (where: WorklogWhereInput) => Promise<ActiveWorklog[]>
  setStoredWorklogId: (worklogId: string) => void
  clearStoredWorklogId: () => void
}

export const ACTIVE_WORKLOG_ORDER_BY = [{ created_at: SortOrder.Desc }]

export function isPendingWorklog(worklog: ActiveWorklog | null | undefined): worklog is ActiveWorklog {
  return Boolean(worklog && worklog.deleted_at == null && worklog.end_time == null)
}

export async function resolveActiveWorklog({
  userId,
  storedWorklogId,
  fetchWorklogs,
  setStoredWorklogId,
  clearStoredWorklogId,
}: ResolveActiveWorklogParams): Promise<ActiveWorklog | undefined> {
  if (!userId) {
    clearStoredWorklogId()
    return undefined
  }

  if (storedWorklogId) {
    const byId = await fetchWorklogs({
      id: { equals: storedWorklogId },
      user_id: { equals: userId },
      deleted_at: { equals: null },
    })

    const storedWorklog = byId[0]
    if (isPendingWorklog(storedWorklog)) {
      setStoredWorklogId(storedWorklog.id)
      return storedWorklog
    }

    clearStoredWorklogId()
  }

  const pending = await fetchWorklogs({
    user_id: { equals: userId },
    deleted_at: { equals: null },
    end_time: { equals: null },
  })

  const activeWorklog = pending.find(isPendingWorklog)
  if (activeWorklog) {
    setStoredWorklogId(activeWorklog.id)
    return activeWorklog
  }

  clearStoredWorklogId()
  return undefined
}
